function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "16",
  viewBox: "0 0 14 14",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.464 5.41a.556.556 0 00-.16-.41l-.813-.804a.55.55 0 00-.402-.17.55.55 0 00-.402.17L6.046 7.83 4.027 5.813c-.113-.114-.247-.17-.402-.17s-.289.056-.402.17l-.812.803a.556.556 0 00-.161.41c0 .162.054.295.16.403l3.233 3.232a.55.55 0 00.402.17.56.56 0 00.41-.17l4.849-4.848a.545.545 0 00.16-.402zm2.25 1.447c0 1.244-.306 2.392-.92 3.442s-1.444 1.882-2.495 2.496-2.198.92-3.442.92-2.391-.307-3.442-.92A6.826 6.826 0 01.92 10.299C.307 9.25 0 8.101 0 6.857s.307-2.391.92-3.442A6.826 6.826 0 013.415.92C4.465.307 5.613 0 6.857 0S9.248.307 10.3.92a6.826 6.826 0 012.496 2.495c.613 1.05.92 2.198.92 3.442z",
  fill: "#2e7ec6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.464 5.41a.556.556 0 00-.16-.41l-.813-.804a.55.55 0 00-.402-.17.55.55 0 00-.402.17l-1.82 1.817L6.044 7.83 4.027 5.813c-.113-.114-.247-.17-.402-.17s-.289.056-.402.17l-.812.803a.556.556 0 00-.161.41c0 .162.054.295.16.403l3.233 3.232a.55.55 0 00.402.17.56.56 0 00.41-.17l4.849-4.848a.545.545 0 00.16-.402z",
  fill: "#fff"
}))));